import * as Sentry from '@sentry/react';
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { initAnalytics } from './shared/lib/consent';
import "./i18n";
import "./styles/index.css";

// ---------------------------------------------------------------------------
// Sentry — error monitoring (legitimate interest, no consent needed)
// Only active in production (VITE_SENTRY_DSN must be set)
// ---------------------------------------------------------------------------
Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.MODE,
  enabled: import.meta.env.PROD && !!import.meta.env.VITE_SENTRY_DSN,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({ maskAllText: true, blockAllMedia: true }),
  ],
  tracesSampleRate: 0.1,
  replaysSessionSampleRate: 0.05,
  replaysOnErrorSampleRate: 1.0,
});

// ---------------------------------------------------------------------------
// PostHog — product analytics (cookieless by default, upgrades on consent)
// Initializes in memory-only mode; upgrades to full persistence after accept
// ---------------------------------------------------------------------------
initAnalytics();

// ---------------------------------------------------------------------------
// Global error handlers
// ---------------------------------------------------------------------------
window.addEventListener("unhandledrejection", (event) => {
  console.error("Unhandled promise rejection:", event.reason);
  Sentry.captureException(event.reason);
});

window.addEventListener("error", (event) => {
  Sentry.captureException(event.error ?? new Error(event.message));
});

createRoot(document.getElementById("root")!).render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);
